import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  rowWrapper: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "40px 1fr",
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "30px 1fr"
    },
    "&.regulatoryVetView": {
      gridTemplateColumns: "1fr"
    }
  },
  tableBodyRow: {
    display: "grid",
    cursor: "pointer",
    gridTemplateColumns:
      "minmax(200px, 1fr) minmax(200px, 1fr) 92px 52px 140px 104px 128px 120px",
    [theme.breakpoints.up("xl")]: {
      gridTemplateColumns:
        "minmax(200px, 1fr) minmax(200px, 1fr) 92px 52px 140px 104px 128px 390px"
    },
    columnGap: 8,
    height: 55,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "65% 35%",
      "&$customizedForMobile": {
        gridTemplateColumns: "minmax(170px, 45%) minmax(80px, 30%) 18%"
      }
    },
    paddingRight: 24,
    [theme.breakpoints.down("xs")]: {
      paddingRight: 16
    },
    "&.regulatoryVetView": {
      paddingLeft: 24,
      [theme.breakpoints.down("xs")]: {
        paddingLeft: 16
      }
    }
  },
  tableCellLink: {
    textDecoration: "none",
    alignItems: "center",
    display: "flex",
    fontSize: 14,
    color: "#232323",
    whiteSpace: "nowrap",
    textAlign: "inherit"
  },
  customizedForMobile: {},
  hideOnTablet: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  dotsIcon: {
    color: theme.palette.secondary.dark
  }
}));
